<template>
  <div>
    
    <b-modal id="dataModal" ref="dataModal" size="lg" :title="title">
      <form>

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="outlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            :disabled="this.dataID ? true : false"
            openDirection="below">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="form-group">
          <label class="form-label">Staff</label>
          <multiselect
            v-model="staff"
            label="text"
            track-by="staffID"
            :options="staffsSelect"
            :searchable="true"
            :show-labels="false"
            :disabled="this.dataID ? true : false"
            openDirection="below">
            <template slot="singleLabel" slot-scope="{ option }">{{ option && option.staffID ? option.name + ' - ' + option.mobile : '' }}</template>
            <template slot="option" slot-scope="{ option }">{{ option.name + ' - ' + option.mobile }}</template>
          </multiselect>
        </div>

        <div class="form-group">
          <label class="form-label">Start Date</label>
          <date-range-picker
            class="w-100"
            ref="picker"
            v-model="dateStart"
            :opens="'right'"
            :minDate="dateStartMin"
            :singleDatePicker="true"
            :timePicker="false"
            :showDropdowns="true"
            :ranges="false"
            :always-show-calendars="true"
            :disabled="this.dataID ? true : false"
            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
            :autoApply="true"
            @update="onDateStartChange">
          </date-range-picker>
        </div>

        <div class="form-group">
          <label class="form-label">End Date</label>
          <date-range-picker
            class="w-100"
            ref="picker"
            v-model="dateEnd"
            :opens="'right'"
            :minDate="dateEndMin"
            :singleDatePicker="true"
            :timePicker="false"
            :showDropdowns="true"
            :ranges="false"
            :always-show-calendars="true"
            :disabled="this.dataID ? true : false"
            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
            :autoApply="true"
            @update="onDateEndChange">
          </date-range-picker>
        </div>

        <div class="form-group">
          <label class="form-label">Leave Type</label>
          <!-- :disabled="this.dataID && (this.statusOriginal === 'approved' || this.statusOriginal === 'rejected') ? true : false" -->
          <multiselect
            v-model="leaveType"
            label="text"
            track-by="typeID"
            :options="leaveTypes"
            :searchable="true"
            :show-labels="false"
            :max-height="150"
            @open="showSpace = true"
            @close="showSpace = false"
            openDirection="below">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.type }}</template>
            <template slot="option" slot-scope="{ option }">{{ option.type }}</template>
          </multiselect>
        </div>

        <div v-if="showStatus" class="form-group">
          <label class="form-label">Status</label>

          <!-- :disabled="this.dataID && (this.statusOriginal === 'approved' || this.statusOriginal === 'rejected')" -->
          <b-form-group
            v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              id="status"
              v-model="status"
              :options="statuses"
              :aria-describedby="ariaDescribedby"
              name="status">
            </b-form-radio-group>
          </b-form-group>

        </div>

        <div v-if="showStatus && status === 'rejected'" class="form-group">
          <label class="form-label">Reject Reason</label>
          <input
            class="form-control bg-transparent pl-3"
            v-model="reject">
        </div>

        <br/>
        <br/>
        <br/>

      </form>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div v-if="dataID" class="col-auto">
            <b-button variant="warning" @click="confirmDeleteItem">Delete</b-button>
          </div>
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="save">{{ $t('button_link.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="confirmDeleteModal" ref="confirmDeleteModal" size="lg" title="Delete Leave">
      <div>Are you sure you want to delete this leave?</div>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="deleteItem">Yes</b-button>
          </div>
        </div>
      </template>
    </b-modal>

  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import Swal from "sweetalert2";

export default {
  name: 'form',
  props: {
    outlets: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
    staffs: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
    leaveTypes: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
  },
  components: {
    DateRangePicker
  },
  data() {
    let temp = moment().add(1, 'day').startOf('day').toDate()

    return {
      title: '',
      showDelete: false,
      showSpace: false,
      statuses: [
        { value: 'approved', text: 'Approved' },
        { value: 'rejected', text: 'Rejected' },
      ],
      staffsSelect: [],

      dataID: '',
      outlet: null,
      staff: {},
      dateStart: { startDate: temp, endDate: temp },
      dateEnd: {},
      dateStartMin: temp,
      dateEndMin: temp,
      leaveType: '',
      showStatus: false,
      statusOriginal: '',
      status: '',
      reject: '',
    }
  },
  watch: {
    "$i18n.locale"(val) {
    },
    outlet(val) {
      this.staffsSelect = []
      let staffInSelection = false
      for(let staff of this.staffs) {
        if(val['id'] === 'all' || staff['outletID'] === val['id']) {
          this.staffsSelect.push(staff)

          if(this.staff['staffID'] === staff['staffID']) {
            staffInSelection = true
          }
        }
      }

      if(!staffInSelection) {
        this.staff = this.staffsSelect[0]
      }
    },
  },
  methods: {
    onDateStartChange(date) {
      this.dateStart = date
      this.dateEndMin = date['startDate']

      if (this.dateEnd && this.dateEnd['startDate'] && this.dateEnd['startDate'].getTime() < date['startDate'].getTime()) {
        this.dateEnd = date
      }
    },
    onDateEndChange(date) {
      this.dateEnd = date
    },
    show(outlet, item, date, staffID) {
      this.$refs['dataModal'].show()

      this.outlet = outlet
      
      if (!item) {
        this.title = 'Add Leave'
        this.showDelete = false

        this.dataID = ''
        let selectedStaff = this.staffs.find(k => k['staffID'] === staffID)
        this.staff = selectedStaff || this.staffs[0]
        let temp = moment().add(1, 'day').startOf('day').toDate()
        if(date) {
          temp = date
        }
        this.dateStart = { startDate: temp, endDate: temp }
        this.dateEnd = { startDate: temp, endDate: temp }
        this.leaveType = this.leaveTypes[0]
        this.showStatus = true
        this.status = ''
        this.statusOriginal = this.status

        return
      }

      this.title = 'Edit Leave'
      this.showDelete = true

      this.dataID = item['leaveID']
      this.staff = this.staffs.find(k => k['staffID'] === item['staffID'])
      let temp1 = moment.unix(item['startDate']).toDate()
      this.dateStart = { startDate: temp1, endDate: temp1 }
      this.dateEndMin = temp1
      let temp2 = moment.unix(item['stopDate']).toDate()
      this.dateEnd = { startDate: temp2, endDate: temp2 }
      this.leaveType = this.leaveTypes.find(k => k['typeID'] === item['typeID'])

      this.showStatus = true
      this.status = ''
      if (item['approvedDate']) {
        this.status = 'approved'
        this.showDelete = false
      } else if (item['rejectedDate'] || item['startDate'] <= moment().startOf('day').unix()) {
        this.status = 'rejected'
        this.showDelete = false
      }
      this.statusOriginal = this.status
      this.reject = item['reject']
    },

    save() {
      let request = {}
      request['typeID'] = this.leaveType['typeID']

      let url
      if (this.dataID) {
        url = `https://staff.tunai.io/business/staff/${this.staff.staffID}/leave/${this.dataID}/update`
      } else {
        request['startDate'] = moment(this.dateStart.startDate.getTime()).startOf('day').unix()
        request['stopDate'] = moment(this.dateEnd.startDate.getTime()).endOf('day').unix()

        url = `https://staff.tunai.io/business/staff/${this.staff.staffID}/leave`
      }

      this.$axios({
        method: 'post',
        url: url,
        headers: { token: this.$util.getSessionToken() },
        data: request,
      })
        .then((response) => {
          if (this.status === 'approved' || this.status === 'rejected') {
            this.changeLeaveStatus(response.data.leaves[0]['leaveID'])
            return
          }

          Swal.fire({
            icon: "success",
            title: this.dataID ? 'Update Leave' : 'Add Leave',
            text: this.dataID ? 'Successfully update leave' : 'Successfully add leave',
          });

          this.$refs['dataModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },
    changeLeaveStatus(dataID) {
      let request = {}
      request['reject'] = this.reject

      let url = `https://staff.tunai.io/business/staff/${this.staff.staffID}/leave/${dataID}/`
      if (this.status === 'approved') {
        url += 'approve'
      } else if (this.status === 'rejected') {
        url += 'reject'
      }

      this.$axios({
        method: 'post',
        url: url,
        headers: { token: this.$util.getSessionToken() },
        data: request,
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: this.dataID ? 'Update Leave' : 'Add Leave',
            text: this.dataID ? 'Successfully update leave' : 'Successfully add leave',
          });

          this.$refs['dataModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },
    confirmDeleteItem() {
      this.$refs['confirmDeleteModal'].show()
    },
    deleteItem() {
      let url = `https://staff.tunai.io/business/staff/${this.staff.staffID}/leave/${this.dataID}/delete`

      this.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: 'Delete Leave',
            text: 'Successfully delete leave',
          });

          this.$refs['confirmDeleteModal'].hide()
          this.$refs['dataModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },

    closeModal(isError) {
      if (!isError) {
        this.$refs['dataModal'].hide()
        this.$emit('onModalClose')
      }
    }
  },
  async mounted() {
  }
}
</script>
<style scoped>
.show {
  display: block;
}

.nav-link,
.link {
  cursor: pointer;
}

.img-thumbnail {
  width: 20em;
}

.item-image {
  width: 8em;
  opacity: .5;
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}
</style>